/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NDC_ALREADY_ADDED } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchAlllabelerList = (data) => ({
  type: actionTypes.GET_ALL_RCA_LABELER_LIST,
  labelerList: data,
});

export const getLabelerList = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_ALL_RCA_LABELER_LIST, values)
    .then((response) => {
      dispatch(dispatchAlllabelerList(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAlllabelerList({ error: 'API failed' }));
    });
};
export const setNDCErrorPopupMessage = (payload) => {
  return {
    type: actionTypes.NDC_ERROR_POPUP_MESSAGE,
    payload,
  };
};

export const setSearchByDrugNameTableData = (payload) => {
  return {
    type: actionTypes.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA,
    payload,
  };
};

export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA,
  dropdown: data,
});

export const searchNDCByIDORDrugName = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data.map((item) => {
        return {
          ...item,
          ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
        };
      });
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const setNDCLoading = (payload) => {
  return {
    type: actionTypes.NDC_LOADING,
    payload,
  };
};

export const setNDCDetailsTableData = (payload) => {
  return {
    type: actionTypes.NDC_DETAILS_TABLE_DATA,
    payload,
  };
};

export const setNDCDetailsTableRowSelected = (payload) => {
  return {
    type: actionTypes.NDC_DETAILS_TABLE_ROW_SELECTED,
    payload,
  };
};

export const dispatchRequestClaim = (payload) => {
  return {
    type: actionTypes.ADD_REQUESTCLAIM_AUDIT,
    payload,
  };
};

export const dispatchAllNDCForLabeller = (data) => ({
  type: actionTypes.GET_UC_NDC_BY_LABELLER,
  ndcListFromLabeller: data,
});

export const checkNDCAndAddToDetailsTable = (
  data,
  arraylist,
  rightNdcTable
) => {
  return (dispatch, getState) => {
    dispatch(setNDCLoading(true));
    if (data.length > 0) {
      let leftData = arraylist;
      let rightData = [];
      arraylist.filter((item) => {
        let getlist = data.find((li) => {
          if (item.ndc === li.ndc) {
            return item;
          }
        });
        if (getlist !== undefined) {
          rightData.push(item);
        }
      });

      rightData = [...rightNdcTable, ...data];
      let result = [];
      let duplicateDate = [];
      rightData.forEach((ele, ind) => {
        if (ind === rightData.findIndex((elem) => elem.ndc === ele.ndc)) {
          result.push(ele);
        } else {
          duplicateDate.push(ele);
        }
      });

      if (duplicateDate.length > 0) {
        dispatch(duplicateError([NDC_ALREADY_ADDED]));
      } else {
        dispatch(setRightTableData(result));
      }
    }
    dispatch(setNDCLoading(false));
  };
};

export const removeFromNDCDetailsTableData = (
  data,
  rightNdcTable,
  leftNdcTable
) => {
  return (dispatch, getState) => {
    if (data.length > 0) {
      let leftData = [];
      let rightData = [];
      rightNdcTable.filter((item) => {
        let getlist = data.find((li) => {
          if (item.ndc === li.ndc) {
            return item;
          }
        });
        if (getlist !== undefined) {
          leftData.push(item);
        } else {
          rightData.push(item);
        }
      });

      dispatch(setLeftTableData(leftNdcTable));
      dispatch(setRightTableData(rightData));
    }
  };
};

export const setMoveAllDatasLefttoRight = (leftNdcTable, rightNdcTable) => {
  return (dispatch, getState) => {
    dispatch(setRightTableData(leftNdcTable));
  };
};

export const setMoveAllDatasRighttoLeft = (rightNdcTable, leftNdcTable) => {
  return (dispatch, getState) => {
    dispatch(setRightTableData([]));
  };
};

export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const getNDCByLabeller = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_LIST_BY_LABELER, values)
    .then((response) => {
      dispatch(dispatchAllNDCForLabeller(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAllNDCForLabeller({ error: 'API failed' }));
    });
};

export const requestRunNow = async (values) => {
  try {
    let response = await axios({
      url: serviceEndPoint.PROCESS_REQUEST_CLAIM_AUDIT,
      data: values,
      method: 'POST',
    });
    return response;
  } catch (err) {
    console.log(err.response.data, 'error');
    throw err.response.data;
  }
};

export const requestClaimFields = (payload) => {
  return {
    type: actionTypes.REQUESTCLAIM_INPUT_VALUES,
    payload,
  };
};

export const requestClaimErrors = (payload) => {
  return {
    type: actionTypes.REQUESTCLAIM_ERRORS,
    payload,
  };
};

export const setLeftTableData = (payload) => {
  return {
    type: actionTypes.LEFT_SIDE_TABLEDETAILS,
    payload,
  };
};

export const setRightTableData = (payload) => {
  return {
    type: actionTypes.RIGHT_SIDE_TABLEDETAILS,
    payload,
  };
};

export const duplicateError = (payload) => {
  return {
    type: actionTypes.DUPLICATE_ERRORS,
    payload,
  };
};

export const clearPreloadedData = (payload) => {
  return {
    type: actionTypes.CLEAR_PRELOADED_DATA,
  };
};
